import { render } from "./AboutInfo.vue?vue&type=template&id=007cb1c0&scoped=true"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"

import "./AboutInfo.vue?vue&type=style&index=0&id=007cb1c0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007cb1c0"]])

export default __exports__